import { render, staticRenderFns } from "./Applicant.vue?vue&type=template&id=58d31fad&scoped=true"
import script from "./Applicant.vue?vue&type=script&lang=js"
export * from "./Applicant.vue?vue&type=script&lang=js"
import style0 from "./applicant.css?vue&type=style&index=0&id=58d31fad&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d31fad",
  null
  
)

export default component.exports